export default __webpack_public_path__ + "static/media/Marine.24ea3148.svg";